const icons = document.querySelectorAll('lord-icon')

if (icons.length) {
    let player
    const loadPlayer = () => {
        player ??= import('@lordicon/element').then(({ defineElement }) => defineElement())
        return player
    }

    if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver((entries) => {
            if (entries.some((entry) => entry.isIntersecting)) {
                observer.disconnect()
                loadPlayer()
            }
        }, { rootMargin: '200px' })

        icons.forEach((icon) => observer.observe(icon))
    } else {
        loadPlayer()
    }
}
